import { render, staticRenderFns } from "./EssEmployeeLeaves.vue?vue&type=template&id=21ebe9f6"
import script from "./EssEmployeeLeaves.vue?vue&type=script&lang=js"
export * from "./EssEmployeeLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports